import Header from "../../components/Menu";
import Substratos from "../../components/Substrato";

const SubstratoPage = () => {
  return (
    <div className="flex">
      <Header />
      <Substratos />
    </div>
  );
};

export default SubstratoPage;
